import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useAuthStore } from "@/store/auth-store";
import { AppLayout } from "@/layouts/AppLayout";
import { SignInPage } from "@/pages/SignInPage";
import { AuthCallbackPage } from "@/pages/AuthCallbackPage";
import { PairPage } from "@/pages/PairPage";
import { AccountsPage } from "@/pages/AccountsPage";
import { AddAccountPage } from "@/pages/AddAccountPage";
import { BotsPage } from "@/pages/BotsPage";
import { BotDetailPage } from "@/pages/BotDetailPage";
import { AlgoBuilderPage } from "@/pages/AlgoBuilderPage";
import { MarketplacePage } from "@/pages/MarketplacePage";
import { MarketplaceDetailPage } from "@/pages/MarketplaceDetailPage";
import { TestingPage } from "@/pages/TestingPage";
import { TestingSessionPage } from "@/pages/TestingSessionPage";
import { ListsPage } from "@/pages/ListsPage";
import { ListDetailPage } from "@/pages/ListDetailPage";
import { ProfilePage } from "@/pages/ProfilePage";
import { HelpPage } from "@/pages/HelpPage";
import { BuyingPowerPage } from "@/pages/BuyingPowerPage";

function RequireAuth({ children }: { children: React.ReactNode }) {
  const signedIn = useAuthStore((s) => s.signedIn);
  const location = useLocation();
  if (!signedIn) return <Navigate to="/sign-in" replace state={{ from: location }} />;
  return <>{children}</>;
}

function RootRedirect() {
  const signedIn = useAuthStore((s) => s.signedIn);
  return <Navigate to={signedIn ? "/accounts" : "/sign-in"} replace />;
}

export function App() {
  return (
    <Routes>
      <Route path="/" element={<RootRedirect />} />
      <Route path="/sign-in" element={<SignInPage />} />
      <Route path="/auth/callback" element={<AuthCallbackPage />} />
      <Route path="/pair" element={<PairPage />} />

      <Route element={<RequireAuth><AppLayout /></RequireAuth>}>
        <Route path="/accounts"            element={<AccountsPage />} />
        <Route path="/accounts/new"        element={<AddAccountPage />} />
        <Route path="/bots"                element={<BotsPage />} />
        <Route path="/bots/:botId"         element={<BotDetailPage />} />
        <Route path="/algo"                element={<AlgoBuilderPage />} />
        <Route path="/marketplace"         element={<MarketplacePage />} />
        <Route path="/marketplace/:id"     element={<MarketplaceDetailPage />} />
        <Route path="/testing"             element={<TestingPage />} />
        <Route path="/testing/:sessionId"  element={<TestingSessionPage />} />
        <Route path="/lists"               element={<ListsPage />} />
        <Route path="/lists/:id"           element={<ListDetailPage />} />
        <Route path="/profile"             element={<ProfilePage />} />
        <Route path="/help"                element={<HelpPage />} />
        <Route path="/buying-power"        element={<BuyingPowerPage />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
